module.exports = __webpack_public_path__ + "static/media/Armor.09a80db5.png";